export default __webpack_public_path__ + "static/media/portfolio-cregar-2.fc5a4768.jpg";